/* global axios */
import ApiClient from './ApiClient';

class SegmentsAPI extends ApiClient {
  constructor() {
    super('segments', { accountScoped: true });
  }

  preview(definition) {
    return axios.post(`${this.url}/preview`, { definition });
  }

  recompute(id) {
    return axios.post(`${this.url}/${id}/recompute`);
  }

  members(id) {
    return axios.get(`${this.url}/${id}/members`);
  }
}

export default new SegmentsAPI();
